import { useState, ReactNode } from "react";
import { Button, Input } from "@pushpress/pushpress-ui";
import { Check, Pencil, X } from "lucide-react";

export const EditableCell = ({
  value,
  onSave,
  displayComponent,
}: {
  value: string | null;
  onSave: (newValue: string) => void;
  displayComponent?: ReactNode;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);

  const handleSave = () => {
    onSave(editValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditValue(value);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="tw-flex tw-items-center tw-gap-1">
        <Input
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          className="tw-h-8 tw-min-w-[180px]"
        />
        <Button variant="outline" size="icon" onClick={handleSave}>
          <Check className="tw-h-4 tw-w-4" />
        </Button>
        <Button variant="outline" size="icon" onClick={handleCancel}>
          <X className="tw-h-4 tw-w-4" />
        </Button>
      </div>
    );
  }

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      {displayComponent ? displayComponent : <span>{value}</span>}
      <Button
        variant="ghost"
        size="icon"
        rounded
        onClick={() => setIsEditing(true)}
      >
        <Pencil className="tw-h-3 tw-w-3" />
      </Button>
    </div>
  );
};
